import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { Colors } from "./colors";

const Theme = (isRTL: boolean) =>
  useMemo(
    () =>
      createTheme({
        palette: {
          mode: "light",
          primary: {
            main: Colors.primary,
            contrastText: Colors.white,
          },
          secondary: {
            main: Colors.secondary,
          },
        },

        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: "none",
              },
            },
          },
        },
        direction: isRTL ? "rtl" : "ltr",
      }),
    [isRTL]
  );

export default Theme;
